import * as t from "io-ts";
import { ActionState } from "./ActionState";
import { BaseId } from "./BaseId";
import { Entry } from "./Entry";

export const Audit = t.intersection([
  BaseId,
  t.type({
    resources: t.array(t.string),
    resource_id: t.string,
    current_action_state: ActionState,
    entries: t.array(Entry),
  }),
]);

export type Audit = BaseId & {
  resources: Array<string>;
  resource_id: string;
  current_action_state: ActionState;
  entries: Array<Entry>;
};
